var _rect, _rect2, _rect3, _path, _rect4, _g, _rect5, _rect6, _path2, _rect7, _g2, _rect8, _line, _line2, _line3, _line4, _line5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobDescriptionBuilder2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1000,
    viewBox: "0 0 1300 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_20)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_20)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_20)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 84,
    width: 1140.09,
    height: 831.391,
    rx: 43.1891,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3_20)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3_20)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -139.907,
    y: 190.695,
    width: 1095,
    height: 1162,
    rx: 52.6197,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3_20)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 348.156,
    y: 349.665,
    width: 983.111,
    height: 224.511,
    rx: 55,
    fill: "url(#paint0_linear_3_20)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M568.773 462.154C568.773 457.928 569.717 454.153 571.604 450.83C573.533 447.465 576.138 444.86 579.421 443.013C582.744 441.126 586.457 440.182 590.56 440.182C595.361 440.182 599.567 441.413 603.177 443.875C606.788 446.337 609.312 449.742 610.748 454.092H600.839C599.854 452.04 598.459 450.501 596.653 449.476C594.889 448.45 592.838 447.937 590.499 447.937C587.996 447.937 585.76 448.532 583.79 449.722C581.862 450.871 580.344 452.512 579.236 454.645C578.169 456.779 577.636 459.282 577.636 462.154C577.636 464.985 578.169 467.488 579.236 469.663C580.344 471.796 581.862 473.458 583.79 474.648C585.76 475.797 587.996 476.371 590.499 476.371C592.838 476.371 594.889 475.858 596.653 474.833C598.459 473.766 599.854 472.207 600.839 470.155H610.748C609.312 474.545 606.788 477.972 603.177 480.433C599.608 482.854 595.402 484.065 590.56 484.065C586.457 484.065 582.744 483.141 579.421 481.295C576.138 479.408 573.533 476.802 571.604 473.479C569.717 470.155 568.773 466.38 568.773 462.154ZM633.248 484.249C629.965 484.249 627.011 483.531 624.385 482.095C621.759 480.618 619.687 478.546 618.169 475.879C616.692 473.212 615.953 470.135 615.953 466.647C615.953 463.159 616.712 460.082 618.23 457.415C619.789 454.748 621.903 452.697 624.57 451.26C627.237 449.783 630.211 449.045 633.494 449.045C636.776 449.045 639.751 449.783 642.418 451.26C645.085 452.697 647.178 454.748 648.696 457.415C650.255 460.082 651.034 463.159 651.034 466.647C651.034 470.135 650.234 473.212 648.634 475.879C647.075 478.546 644.941 480.618 642.233 482.095C639.566 483.531 636.571 484.249 633.248 484.249ZM633.248 476.741C634.807 476.741 636.263 476.371 637.617 475.633C639.012 474.853 640.12 473.704 640.941 472.186C641.761 470.668 642.172 468.822 642.172 466.647C642.172 463.406 641.31 460.923 639.587 459.2C637.905 457.436 635.833 456.553 633.371 456.553C630.909 456.553 628.837 457.436 627.154 459.2C625.513 460.923 624.693 463.406 624.693 466.647C624.693 469.888 625.493 472.391 627.093 474.156C628.734 475.879 630.786 476.741 633.248 476.741ZM665.971 454.522C667.079 452.963 668.597 451.671 670.526 450.645C672.495 449.578 674.732 449.045 677.234 449.045C680.148 449.045 682.774 449.763 685.112 451.199C687.492 452.635 689.359 454.687 690.713 457.354C692.108 459.98 692.806 463.036 692.806 466.524C692.806 470.012 692.108 473.109 690.713 475.817C689.359 478.484 687.492 480.556 685.112 482.034C682.774 483.511 680.148 484.249 677.234 484.249C674.732 484.249 672.516 483.736 670.587 482.711C668.7 481.685 667.161 480.392 665.971 478.833V499.944H657.355V449.599H665.971V454.522ZM684.004 466.524C684.004 464.472 683.574 462.708 682.712 461.231C681.891 459.713 680.784 458.564 679.389 457.784C678.034 457.005 676.557 456.615 674.957 456.615C673.398 456.615 671.921 457.025 670.526 457.846C669.172 458.625 668.064 459.774 667.202 461.292C666.382 462.811 665.971 464.595 665.971 466.647C665.971 468.699 666.382 470.483 667.202 472.002C668.064 473.52 669.172 474.689 670.526 475.51C671.921 476.289 673.398 476.679 674.957 476.679C676.557 476.679 678.034 476.269 679.389 475.448C680.784 474.628 681.891 473.458 682.712 471.94C683.574 470.422 684.004 468.617 684.004 466.524ZM731.687 449.599L710.576 499.82H701.406L708.791 482.834L695.128 449.599H704.791L713.592 473.417L722.516 449.599H731.687Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_20",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 429,
    y: 418,
    width: 91,
    height: 92
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 429.093,
    y: 418.695,
    width: 90.5608,
    height: 90.5608,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.053 486.616C460.978 486.616 459.201 485.877 457.723 484.399C456.245 482.921 455.506 481.145 455.506 479.069V433.789C455.506 431.713 456.245 429.937 457.723 428.459C459.201 426.981 460.978 426.242 463.053 426.242H497.013C499.089 426.242 500.865 426.981 502.343 428.459C503.821 429.937 504.56 431.713 504.56 433.789V479.069C504.56 481.145 503.821 482.921 502.343 484.399C500.865 485.877 499.089 486.616 497.013 486.616H463.053ZM463.053 479.069H497.013V433.789H463.053V479.069ZM447.96 501.709C445.884 501.709 444.108 500.97 442.63 499.493C441.152 498.015 440.413 496.238 440.413 494.163V445.109C440.413 444.04 440.774 443.144 441.498 442.42C442.221 441.697 443.117 441.336 444.186 441.336C445.255 441.336 446.152 441.697 446.875 442.42C447.598 443.144 447.96 444.04 447.96 445.109V494.163H485.693C486.762 494.163 487.659 494.524 488.382 495.248C489.105 495.971 489.467 496.867 489.467 497.936C489.467 499.005 489.105 499.901 488.382 500.625C487.659 501.348 486.762 501.709 485.693 501.709H447.96Z",
    fill: "white"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 349.194,
    y: 350.704,
    width: 981.034,
    height: 222.434,
    rx: 53.9617,
    stroke: "#DCEDF8",
    strokeWidth: 2.07656
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3_20)"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 507.093,
    y: 639.695,
    width: 761.236,
    height: 173.842,
    rx: 39,
    fill: "url(#paint1_linear_3_20)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M686.212 714.944V723.284H697.411V728.574H686.212V737.39H698.841V742.823H679.54V709.512H698.841V714.944H686.212ZM703.188 729.527C703.188 726.858 703.713 724.491 704.761 722.426C705.841 720.361 707.303 718.773 709.145 717.661C710.988 716.549 713.037 715.993 715.293 715.993C717.009 715.993 718.645 716.374 720.202 717.136C721.758 717.867 722.998 718.852 723.919 720.091V707.558H730.686V742.823H723.919V738.915C723.093 740.218 721.933 741.266 720.44 742.061C718.947 742.855 717.215 743.252 715.245 743.252C713.022 743.252 710.988 742.68 709.145 741.536C707.303 740.393 705.841 738.788 704.761 736.723C703.713 734.626 703.188 732.228 703.188 729.527ZM723.967 729.622C723.967 728.002 723.649 726.62 723.013 725.476C722.378 724.301 721.52 723.411 720.44 722.808C719.36 722.172 718.2 721.854 716.961 721.854C715.722 721.854 714.578 722.156 713.53 722.76C712.481 723.364 711.624 724.253 710.956 725.429C710.321 726.572 710.003 727.939 710.003 729.527C710.003 731.116 710.321 732.514 710.956 733.721C711.624 734.896 712.481 735.802 713.53 736.437C714.61 737.073 715.754 737.39 716.961 737.39C718.2 737.39 719.36 737.089 720.44 736.485C721.52 735.849 722.378 734.96 723.013 733.816C723.649 732.641 723.967 731.243 723.967 729.622ZM740.586 713.276C739.41 713.276 738.425 712.911 737.631 712.18C736.869 711.418 736.487 710.481 736.487 709.369C736.487 708.257 736.869 707.335 737.631 706.604C738.425 705.842 739.41 705.461 740.586 705.461C741.761 705.461 742.73 705.842 743.493 706.604C744.287 707.335 744.684 708.257 744.684 709.369C744.684 710.481 744.287 711.418 743.493 712.18C742.73 712.911 741.761 713.276 740.586 713.276ZM743.874 716.422V742.823H737.202V716.422H743.874ZM758.234 721.902V734.674C758.234 735.564 758.44 736.215 758.853 736.628C759.298 737.009 760.029 737.2 761.046 737.2H764.143V742.823H759.95C754.326 742.823 751.514 740.091 751.514 734.626V721.902H748.369V716.422H751.514V709.893H758.234V716.422H764.143V721.902H758.234Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3_20",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 569,
    y: 690,
    width: 77,
    height: 77
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 569.764,
    y: 690.823,
    width: 75.8828,
    height: 75.8828,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M585.572 750.897H589.999L617.269 723.627L612.843 719.2L585.572 746.471V750.897ZM630.786 719.042L617.348 705.763L621.775 701.336C622.987 700.124 624.476 699.518 626.241 699.518C628.006 699.518 629.495 700.124 630.707 701.336L635.133 705.763C636.345 706.975 636.978 708.437 637.03 710.15C637.083 711.862 636.503 713.325 635.291 714.537L630.786 719.042ZM582.411 757.221C581.515 757.221 580.764 756.918 580.158 756.312C579.552 755.706 579.249 754.955 579.249 754.059V745.127C579.249 744.705 579.328 744.297 579.486 743.902C579.644 743.506 579.881 743.151 580.197 742.834L612.764 710.268L626.201 723.706L593.635 756.272C593.319 756.588 592.963 756.825 592.568 756.983C592.173 757.142 591.764 757.221 591.343 757.221H582.411Z",
    fill: "white"
  }))))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -136.407,
    y: 194.195,
    width: 1088,
    height: 1155,
    rx: 49.1197,
    stroke: "#205DD4",
    strokeWidth: 7
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 890.093,
    y1: 162.695,
    x2: 890.093,
    y2: 124.695,
    stroke: "#205BD3",
    strokeOpacity: 0.2,
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 930.542,
    y1: 164.37,
    x2: 954.37,
    y2: 112.458,
    stroke: "#205BD3",
    strokeOpacity: 0.5,
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 980.75,
    y1: 210.486,
    x2: 1035.49,
    y2: 188.25,
    stroke: "#205BD3",
    strokeOpacity: 0.5,
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 982,
    y1: 248,
    x2: 1019,
    y2: 248,
    stroke: "#205BD3",
    strokeOpacity: 0.2,
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 964.059,
    y1: 178.929,
    x2: 1016.93,
    y2: 126.941,
    stroke: "#205BD3",
    strokeOpacity: 0.8,
    strokeWidth: 10,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_20",
    x: 7,
    y: 11,
    width: 1300.09,
    height: 991.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3_20",
    x: -170.607,
    y: 160.001,
    width: 1165.16,
    height: 1232.16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.38,
    dy: 4.38497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3_20",
    x: 301.433,
    y: 313.326,
    width: 1066.17,
    height: 307.573,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.1914,
    dy: 5.1914
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.7656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3_20",
    x: 470.915,
    y: 611.557,
    width: 825.552,
    height: 238.158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.01978,
    dy: 4.01978
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.0791
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_20",
    x1: 348.093,
    y1: 461.695,
    x2: 1060.59,
    y2: 461.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E50D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_20",
    x1: 507.044,
    y1: 726.442,
    x2: 1058.74,
    y2: 726.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2765DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1300,
    height: 1000,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 84,
    width: 1140.09,
    height: 831.391,
    rx: 43.1891,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3_20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -139.907,
    y: 190.695,
    width: 1095,
    height: 1162,
    rx: 52.6197,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobDescriptionBuilder2);
export default __webpack_public_path__ + "static/media/Job Description Builder_2.53f1ca6a076caa31187703bc74f03ce6.svg";
export { ForwardRef as ReactComponent };